import Luan from '../images/luan_foto_01.png';
import William from '../images/william_foto_01.png';
import Japa from '../images/japa_foto_01.png';

export const teacherData = [
    {
      aula: [
          {
              name: "Luan",
              fullname: "Luan Medeiros",
              instrument: "Bateria",
              description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libero distinctio, obcaecati minus sequi error, molestias necessitatibus harum nobis non. Amet, blanditiis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libeis?",
              image: Luan,
              image2: Luan
          },
          {
              name: "William",
              fullname: "William",
              instrument: "Guitarra/Violão",
              description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libero distinctio, obcaecati minus sequi error, molestias necessitatibus harum nobis non. Amet, blanditiis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libeis?",
              image: William,
              image2: William
          },
          {
              name: "Japa",
              fullname: "Japa",
              instrument: "Baixo",
              description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libero distinctio, obcaecati minus sequi error, molestias necessitatibus harum nobis non. Amet, blanditiis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libeis?",
              image: Japa,
              image2: Japa
          },
      ]
    },
    {
        aula: [

            {
                name: "Fulano",
                fullname: "Fulano",
                instrument: "Canto",
                description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libero distinctio, obcaecati minus sequi error, molestias necessitatibus harum nobis non. Amet, blanditiis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libeis?",
                image: Japa,
                image2: Japa
            },
            {
                name: "Fulano1",
                fullname: "Fulano1",
                instrument: "Sopro",
                description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libero distinctio, obcaecati minus sequi error, molestias necessitatibus harum nobis non. Amet, blanditiis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libeis?",
                image: Luan,
                image2: Luan
            },
            {
                name: "Fulano2",
                fullname: "Fulano2",
                instrument: "Teclado",
                description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libero distinctio, obcaecati minus sequi error, molestias necessitatibus harum nobis non. Amet, blanditiis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia provident esse laboriosam blanditiis iusto porro nesciunt aliquid libeis?",
                image: William,
                image2: William
            },
        ]
    }
]